import { InfoIcon } from 'assets/icons/InfoIcon'
import { Card, CardBody, CardHeader } from 'components/Card/Card'
import { ExclamationMarkIcon } from 'pages/Accomodation/icons/ExclamationMarkIcon'
import { SuccessIcon } from 'pages/Accomodation/icons/SuccessIcon'
import { SuccessIconV2 } from 'pages/Accomodation/icons/SuccessIconV2'
import { WarningIconV2 } from 'pages/Accomodation/icons/WarningIconV2'
import styled, { useTheme } from 'styled-components'
import { colors, ColorVariant, Flex, getColorVariantColor, Icon } from 'styling/GlobalStyles'
import { MediumText, SmallText } from 'styling/TypographyV2'

export enum AlertType {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
}

const AlertIcon = ({ type }: { type: AlertType }) => {
  switch (type) {
    case AlertType.WARNING:
      return <WarningIconV2 color='currentColor' />
    case AlertType.ERROR:
      return <ExclamationMarkIcon color='currentColor' />
    case AlertType.INFO:
      return <InfoIcon color='currentColor' />
    case AlertType.SUCCESS:
      return <SuccessIconV2 />
  }
}

export const Alert = ({
  title,
  description,
  mt,
  mb,
  type = AlertType.ERROR,
  colorVariant = ColorVariant.ERROR,
}: {
  title: string
  description: string
  mt?: string
  mb?: string
  type?: AlertType
  colorVariant?: ColorVariant
}) => {
  return (
    <AlertContainer mt={mt} mb={mb} colorVariant={colorVariant}>
      <AlertIcon type={type} />
      <Flex column>
        <MediumText bold hexColor='inherit' mb='0.25rem'>
          {title}
        </MediumText>
        <SmallText semibold colorVariant={ColorVariant.BASE}>
          {description}
        </SmallText>
      </Flex>
    </AlertContainer>
  )
}

export const TextWarning = ({
  title,
  type,
  colorVariant,
}: {
  title: string
  type: AlertType
  colorVariant: ColorVariant
}) => {
  const theme = useTheme()
  return (
    <Flex center gap='0.25rem'>
      <Icon size='16px' color={getColorVariantColor(colorVariant, theme as any)}>
        <AlertIcon type={type} />
      </Icon>
      <MediumText bold colorVariant={colorVariant}>
        {title}
      </MediumText>
    </Flex>
  )
}

const AlertContainer = styled.div<{ mt?: string; mb?: string; colorVariant?: ColorVariant }>`
  margin-top: ${({ mt }) => mt || '0'};
  margin-bottom: ${({ mb }) => mb || '0'};
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  background-color: ${({ colorVariant, theme }) =>
    `${getColorVariantColor(colorVariant, theme)}10`};
  border: 1px solid ${({ colorVariant, theme }) => getColorVariantColor(colorVariant, theme)};
  color: ${({ colorVariant, theme }) => getColorVariantColor(colorVariant, theme)};
  display: flex;
  align-items: center;
  gap: 0.75rem;
`
